import {useRecoilValue} from 'recoil';
import {userState} from '../recoil/user/userAtom';

const useBidmiiProTier = () => {
  const user = useRecoilValue(userState);
  const tier = user?.servicePlan?.replace('BIDMII_PRO_', '');

  const lookup = {
    FREE: 0,
    LITE: 1,
    CORE: 2,
    PLUS: 3,
  };

  return !tier ? 0 : lookup[tier as keyof typeof lookup];
};

export default useBidmiiProTier;
